import React from 'react';

/**
 * Step indicator for paginated public application forms.
 */
export default function FormPageStepper({
  steps = [],
  currentIndex = 0,
  onStepClick,
  allowJump = false,
  /** When true (preview / read-only view), any step label is clickable — not only visited steps. */
  allowForwardJump = false,
}) {
  if (!steps.length || steps.length <= 1) return null;

  return (
    <nav aria-label="Application form progress" className="mb-5">
      <ol className="flex flex-wrap items-center gap-2">
        {steps.map((step, idx) => {
          const isActive = idx === currentIndex;
          const isComplete = idx < currentIndex;
          const clickable = allowJump && onStepClick && (allowForwardJump || isComplete || isActive);

          return (
            <li key={step.id} className="flex items-center gap-2">
              {idx > 0 && <span className="text-gray-300 text-xs">›</span>}
              {clickable ? (
                <button
                  type="button"
                  onClick={() => onStepClick(idx)}
                  className={`inline-flex items-center gap-1.5 rounded-full px-2.5 py-1 text-xs font-medium border transition-colors cursor-pointer hover:border-indigo-300 ${
                    isActive
                      ? 'bg-indigo-600 text-white border-indigo-600'
                      : 'bg-indigo-50 text-indigo-700 border-indigo-200'
                  }`}
                >
                  <StepBadge idx={idx} isActive={isActive} isComplete={isComplete} />
                  <span className="max-w-[10rem] truncate">{step.title || `Page ${idx + 1}`}</span>
                </button>
              ) : (
                <span
                  className={`inline-flex items-center gap-1.5 rounded-full px-2.5 py-1 text-xs font-medium border ${
                    isActive
                      ? 'bg-indigo-600 text-white border-indigo-600'
                      : isComplete
                        ? 'bg-indigo-50 text-indigo-700 border-indigo-200'
                        : 'bg-white text-gray-500 border-gray-200'
                  }`}
                >
                  <StepBadge idx={idx} isActive={isActive} isComplete={isComplete} />
                  <span className="max-w-[10rem] truncate">{step.title || `Page ${idx + 1}`}</span>
                </span>
              )}
            </li>
          );
        })}
      </ol>
    </nav>
  );
}

function StepBadge({ idx, isActive, isComplete }) {
  return (
    <span
      className={`inline-flex h-4 w-4 items-center justify-center rounded-full text-[10px] font-bold ${
        isActive ? 'bg-white/20 text-white' : isComplete ? 'bg-indigo-600 text-white' : 'bg-gray-100 text-gray-500'
      }`}
    >
      {isComplete ? '✓' : idx + 1}
    </span>
  );
}
